module.exports = __webpack_public_path__ + "static/media/bg_top_right.2677bf67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_top_right.svg
// module id = 180
// module chunks = 0